import { SILENT_SOUND } from '$lib/services/audio/constants';

export class AudioPlayer {
    private audio: HTMLAudioElement | undefined;
    private inited = false;

    constructor(private src: string) {}

    async init() {
        // safari on ios only allows to play sounds after user interaction
        // once audio played after user interaction it can be played at any moment after
        // so we need to init audio element playing silent sound after any user interaction to be able to play
        // this audio element at any moment after
        if (!this.inited) {
            const audio = this.getAudio();

            if (audio.src === `${window.location.origin}${this.src}`) {
                audio.src = SILENT_SOUND;
            }

            await audio.play();
            this.inited = true;
        }
    }

    async play() {
        const audio = this.getAudio();

        if (audio.src !== `${window.location.origin}${this.src}`) {
            audio.src = this.src;
        }

        await audio.play();
    }

    private getAudio() {
        if (!this.audio) {
            this.audio = new Audio(SILENT_SOUND);
        }

        return this.audio;
    }
}
